module.exports = __webpack_public_path__ + "static/media/AthenianCitizen.cc65e22a.jpg";